import React, { useMemo } from 'react';
import BuyerCard from 'routes/profile/models/BuyerCard';
import {
  MarketTabs,
  MarketTabList,
  MarketTab,
  MarketTabPanel,
} from '@market/react';
import ReceiptDeliveryOptions from './ReceiptDeliveryOptions';
import {
  CardPreference,
  Product as CardPreferenceProduct,
} from 'routes/profile/models/CardPreference';

type ReceiptCardTabsProps = {
  paymentCards?: BuyerCard[];
  primaryCardId?: string;
  selectedPaymentCardId?: string;
  onCardSelected: (cardsApiId: string) => void;
  cardPreferences: CardPreference[];
  isRetrievePrefsLoading: boolean;
};

const ReceiptCardTabs: React.FC<ReceiptCardTabsProps> = ({
  paymentCards,
  primaryCardId,
  selectedPaymentCardId,
  onCardSelected,
  cardPreferences,
  isRetrievePrefsLoading,
}) => {
  const orderedPaymentCards = useMemo(() => {
    if (!paymentCards) {
      return [];
    }

    const primaryCardIdx = paymentCards.findIndex(
      (card) => card.cardsApiId === primaryCardId
    );
    if (primaryCardIdx === -1) {
      return paymentCards;
    }

    return [
      paymentCards[primaryCardIdx],
      ...paymentCards.slice(0, primaryCardIdx),
      ...paymentCards.slice(primaryCardIdx + 1),
    ];
  }, [paymentCards, primaryCardId]);

  const handleTabChange = (
    event: CustomEvent<{ value: string; prevValue: string }>
  ) => {
    if (event.detail.value) {
      onCardSelected(event.detail.value);
    }
  };

  return (
    <div className={'shadow-bottomDivider'}>
      <MarketTabs selectedTab={selectedPaymentCardId}>
        <MarketTabList onMarketTabListSelectedTabChanged={handleTabChange}>
          {orderedPaymentCards.map((card) => (
            <MarketTab
              key={card.cardsApiId}
              id={card.cardsApiId}
              aria-controls={`panel-${card.cardsApiId}`}
            >
              <span data-testid={'card-display-name'}>{card.displayName}</span>
            </MarketTab>
          ))}
        </MarketTabList>
        {orderedPaymentCards.map((card) => (
          <MarketTabPanel
            key={card.cardsApiId}
            id={`panel-${card.cardsApiId}`}
            aria-labelledby={card.cardsApiId}
          >
            <ReceiptDeliveryOptions
              preferenceCardId={card.preferenceCardId}
              cardPreferences={cardPreferences.filter(
                (pref) => pref.product === CardPreferenceProduct.Receipt
              )}
              isRetrievePrefsLoading={isRetrievePrefsLoading}
            />
          </MarketTabPanel>
        ))}
      </MarketTabs>
    </div>
  );
};

export default ReceiptCardTabs;
